import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useHistory } from 'react-router';
import { Waypoint } from 'react-waypoint';
import { CompanyViewModel, ContactViewModel } from '../../../../viewmodels/AppViewModels';
import EmptyContactsPlaceholderUrl from '../../../assets/emptyContactsPlaceholder.svg';
import { ROUTES } from '../../../constants/routes';
import { baseStyleSheet } from '../../../styles/styles';
import { Placeholder } from '../../Placeholder';
import { PrincipalListItem } from '../../PrincipalListItem';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	company: CompanyViewModel;
}

const _CompanyContactsList: React.FC<IProps> = ({ company, className }) => {
	const history = useHistory();

	React.useEffect(() => {
		company.getContacts();
	}, [company]);

	const scrolledToBottom = () => {
		if (!company.fetchingContacts) {
			// only grab the next batch if we're not fetching
			company.getContacts();
		}
	};

	const getContactRows = () => {
		return (
			!!company.contacts &&
			company.contacts.length > 0 && (
				<ul>
					{company.contacts.map((contact, i) => {
						return (
							<PrincipalListItem
								className={css(styleSheet.item, baseStyleSheet.truncateText)}
								key={contact.id || i}
								onClick={() => onContactClicked(contact)}
								principal={contact.toJs()}
							>
								{!!contact.jobTitle && <div className='truncate-text'>{contact.jobTitle}</div>}
							</PrincipalListItem>
						);
					})}
				</ul>
			)
		);
	};

	const onContactClicked = (contact: ContactViewModel) => {
		if (contact.isValid) {
			history.push(`${ROUTES.contacts.people}/${contact.id}`);
		}
	};

	const loading = !!company.fetchingContacts;
	const isEmpty = !!company.contacts && company.contacts.length === 0;

	return (
		<div className={`${css(styleSheet.list)} ${className || ''}`}>
			{getContactRows()}
			<Placeholder
				isEmpty={isEmpty}
				isLoading={loading}
				message='Does not have any known contacts.'
				placeholderUrl={EmptyContactsPlaceholderUrl}
			/>
			{company.contacts ? <Waypoint bottomOffset='-200px' onEnter={scrolledToBottom} /> : null}
		</div>
	);
};

export const CompanyContactsList = observer(_CompanyContactsList);
